import { render, staticRenderFns } from "./jigouTongji.vue?vue&type=template&id=55466c55&scoped=true&"
import script from "./jigouTongji.vue?vue&type=script&lang=js&"
export * from "./jigouTongji.vue?vue&type=script&lang=js&"
import style0 from "./jigouTongji.vue?vue&type=style&index=0&id=55466c55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55466c55",
  null
  
)

export default component.exports